module.exports = __webpack_public_path__ + "static/media/Automate.2879dfc3.png";